import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    conversations: {},
    unread: {}, 
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    addMessage: (state, action) => {
        const { userId, message } = action.payload;

        console.log('Updating state for userId:', userId);
        console.log('Message:', message);
        
        if (!state.conversations[userId]) {
            state.conversations[userId] = [];
        }

        // Push the new message into the respective conversation
        state.conversations[userId].push(message);

        console.log('Final state:', JSON.stringify(state.conversations, null, 2));
        
        // Increment unread count if not already marked as read
        if (!state.unread[userId]) {
            state.unread[userId] = 1;
        } else {
            state.unread[userId]++;
        }
    },
    markAsRead(state, action) {
      const userId = action.payload;
      state.unread[userId] = 0;
    },
  },
});

export const { addMessage, markAsRead, conversations } = messageSlice.actions;
export default messageSlice.reducer;
